import { DASHBOARD_TAG_ROUTER } from "@Router/routerPath";
import { ChartAdvancedFilterPage } from "@Local/Dashboard";
import { FRONT_KEY } from "@Constants/frontKey";

const dashboardRouter = [
	{
		description: "Dashboard",
		frontKey: FRONT_KEY.DASHBOARD,
	},
	{
		description: "進階查詢",
		frontKey: FRONT_KEY.DASHBOARD_ADVANCED_FILTER,
		static: true,
		path: DASHBOARD_TAG_ROUTER,
		href: DASHBOARD_TAG_ROUTER,
		as: ChartAdvancedFilterPage,
	},
	// {
	// 	description: "會員輪廓",
	// 	frontKey: "D999X12",
	// 	static: true,
	// 	path: DASHBOARD_MEMBER_PROFILE_ROUTER,
	// 	href: DASHBOARD_MEMBER_PROFILE_ROUTER,
	// 	as: MemberPage,
	// },
];

export default dashboardRouter;
